<template>
	<div class="row no-gutters mt-2 query-visualizer">
		<div class="qd-card h-100 col-3 right-sidebar" ref="rightSidebar">
			<button class="section-hider right-hider" ref="rightHider" @click="toggleSection(false)">
				<i class="fas fa-arrow-right-to-line"></i>
			</button>
			<TabHost :activeTab="entitiesActiveTab" @activeTabChanged="entityTabChanged" class="pt-4">
				<TabItem :id="'entity-selector'" name="ساختار">
					<entity-selector :modelValue="selectedEntity" @update:modelValue="selectedEntityChanged" />
				</TabItem>
				<TabItem :id="'entity-column-selector'" name="فیلد ها">
					<div style="height: 100%;display: flex;flex-direction: column;">
						<div class="d-flex justify-content-between align-items-center mb-3">
							<div class="position-relative w-50">
								<input type="text" v-model="searchKeyword" class="structure-search" placeholder="جستجو">
								<i v-if="searchKeyword" @click="searchKeyword = ''" class="fas fa-times empty-entity-search"></i>
							</div>
							<div v-if="selectedEntity" class="selected-title">
								({{ selectedEntity.entityTitle }})
							</div>
						</div>
						<div class="p" style="overflow: auto;height: 100%;">
							<entity-column-selector v-if="selectedEntity" :baseEntity="selectedEntity.entityType" :path="selectedEntity.entityType" :titlePath="selectedEntity.entityTitle" :columns="selectedEntityColumns" :selectedItems="localData.columns" @column-changed="columnChanged" @add-column="addColumn" @remove-column="removeColumn" />
							<div class="alert alert-info" v-else>
								لطفا ابتدا یک ساختار انتخاب کنید
							</div>
						</div>
					</div>
				</TabItem>
			</TabHost>
		</div>
		<div class="col main-section">
			<div class="mx-2 h-100">
				<columns-table v-model:limit="localData.limit" :variables="localData.variables" :columns="localData.columns" @column-changed="columnChanged" @remove-column="removeColumn" @swap-items="(dragged, dropped) => swapItems(dragged, dropped)" />
				<conditions v-if="toggler" :columns="localData.columns" :variables="localData.variables" v-model="localData.conditions" />
				<sorts v-if="toggler" :columns="localData.columns" v-model="localData.sorts" />
			</div>
		</div>
		<div class="col-3 h-100 qd-card left-sidebar" ref="leftSidebar" style="position:unset;">
			<div class="position-relative hider-container">
				<button class="section-hider left-hider" ref="leftHider" @click="toggleSection(true)">
					<i class="fas fa-arrow-left-to-line"></i>
				</button>
			</div>
			<div class="d-flex flex-column">
				<div class="parameters-section">
					<p class="section-title">پارامتر های گزارش:</p>
					<report-parameters />
				</div>
				<div class="variables-section mt-4 pt-4">
					<p class="section-title">متغیر ها:</p>
					<div>
						<variables v-if="toggler" v-model="localData.variables" @add-column="addColumn" @remove-column="removeColumn" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import TabHost from './components/general/tab/tab-host.vue'
	import TabItem from './components/general/tab/tab-item.vue'
	import _ from 'lodash'

	export default {
		name: 'QueryBuilder',
		props: {
			modelValue: {
				type: Object,
			},
		},
		components: {
			TabHost,
			TabItem
		},
		emits: ['update:modelValue'],
		data() {
			return {
				entitiesActiveTab: 'entity-selector',
				toggler: false,
				selectedEntity: null,
				localData: {
					columns: [],
					sorts: [],
					groupBys: [],
					variables: [],
					conditions: null,
				},
				searchKeyword: ''
			}
		},
		mounted() {
			if (this.modelValue) {
				this.localData = { ...this.modelValue }
			}
			if (this.localData?.columns?.length > 0) {
				this.selectedEntity = {
					entityType: this.localData.columns[0].baseEntity
				}
			}
			this.toggler = true
		},
		watch: {
			localData: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.localData)
				},
			},
		},
		computed: {
			selectedEntityColumns() {
				if (!this.selectedEntity) return []

				let items = _.cloneDeep(this.selectedEntity.columns)

				if (this.searchKeyword) {
					return items.filter(item => item.title.indexOf(this.searchKeyword) > -1)
				}

				return items
			}
		},
		methods: {
			toggleSection(isLeftSide) {

				if (isLeftSide) {
					const leftSidebar = this.$refs.leftSidebar
					leftSidebar.classList.toggle('col-0')

					const leftHider = this.$refs.leftHider
					leftHider.classList.toggle('rotate-hider')
				}
				else {
					const rightSidebar = this.$refs.rightSidebar
					rightSidebar.classList.toggle('col-0')

					const rightHider = this.$refs.rightHider
					rightHider.classList.toggle('rotate-hider')
				}


			},
			entityTabChanged(newTab) {
				this.entitiesActiveTab = newTab
				this.searchKeyword = ''
			},
			selectedEntityChanged(entity) {
				this.selectedEntity = entity
				this.entitiesActiveTab = 'entity-column-selector'
			},
			addColumn(column) {
				let findIndex = this.localData.columns.findIndex(
					(col) => col.path === column.path
				)
				if (findIndex === -1 || column.fromVariable) this.localData.columns.push(column)
			},
			removeColumn(column) {
				let findIndex = this.localData.columns.findIndex(
					(col) => col.path === column.path
				)
				if (findIndex > -1) this.localData.columns.splice(findIndex, 1)
			},
			columnChanged(column) {
				let findIndex = this.localData.columns.findIndex(
					(col) => col.path === column.path
				)
				if (findIndex > -1) {
					Object.assign(this.localData.columns[findIndex], column)
				}
			},
			swapItems(dragged, dropped) {
				[this.localData.columns[dragged], this.localData.columns[dropped]] = [this.localData.columns[dropped], this.localData.columns[dragged]]
			}
		},
	}
</script>

<style lang="less">
	@import "./components/styles/app.less";

	.variables-section {
		border-top: 1px solid #e7ecef;
	}

	.query-visualizer {
		height: 87%;
		overflow-x: hidden;
	}

	.main-section,
	.left-sidebar,
	.right-sidebar {
		transition: max-width 300ms ease-in-out, flex-basis 300ms ease-in-out,
			opacity 300ms ease-in-out;
		opacity: 1;
		overflow-x: hidden;
	}

	.right-sidebar.col-0 {
		position: relative !important;
		right: -9px;
	}

	.left-sidebar.col-0 {
		position: relative !important;
		left: -9px;
	}

	.section-hider {
		background-color: white;
		color: @primary-dark;
		width: 20px;
		height: 20px;
		outline: none;
		border: none;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		z-index: 2;
		top: 5px;
		transition: color 200ms ease-in-out, background-color 200ms ease-in-out,
			transform 200ms ease-in-out, right 200ms ease-in-out, left 200ms ease-in-out;

		visibility: visible !important;

		i {
			visibility: visible !important;
		}

		&.rotate-hider {
			transform: rotate(180deg);
		}

		&:hover {
			background-color: @primary-dark;
			color: white;
		}

		&.left-hider {
			right: -4px;
			top: -4px;
		}

		&.right-hider {
			left: 6px;
		}
	}

	.col-0 {
		flex-basis: 3% !important;
		padding: 0 !important;
	}

	.col-0 * {
		white-space: pre;
		flex-wrap: nowrap;
		visibility: hidden;
	}

	.selected-title {
		color: #8f8f8f;
		border-radius: 5px;
		padding: 5px 0;
	}

	.hider-container {
		height: 13px;
	}
</style>